import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { NzModalModule } from 'ng-zorro-antd/modal';

@Component({
  standalone: true,
  selector: 'app-modal-container',
  imports: [NzModalModule],
  templateUrl: './modal-container.component.html',
  styleUrls: ['./modal-container.component.scss'],
  host: {
    ngSkipHydration: '',
  },
})
export class ModalContainerComponent implements OnInit {
  @Input() innerContent: TemplateRef<any>;
  @Input() isVisible = true;
  @Input() nzMaskClosable = false;
  @Input() nzClosable = true;
  @Input() nzWidth: number | string;
  @Input() nzStyle: object = {};
  @Input() nzMaskStyle: object = {};
  @Input() nzWrapClassName: string = 'wizard-popup edit-property-modal';
  //@Input() classes: string = '';
  @Output() canceled = new EventEmitter();
  @Output() afterOpen = new EventEmitter<void>();
  constructor() {}

  ngOnInit(): void { }

  ngOnChanges() {}

  handleCancel() {
    this.canceled.emit();
    this.isVisible = false;
  }
}
